export default {
      id: "logo-ground-services-usage",
      viewBox: "0 0 327 35",
      url: __webpack_public_path__ + "img/icons.507a1d9d.svg#logo-ground-services",
      toString: function () {
        return this.url;
      }
    }